import { render } from "./SubtableModal.vue?vue&type=template&id=d2e8778c"
import script from "./SubtableModal.vue?vue&type=script&lang=js"
export * from "./SubtableModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/melvin/Workspace/Sjef.app/frontend/pos.sjef.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__